import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import * as _ from 'lodash';
import { AmplifyService } from 'aws-amplify-angular';
import { Router, ActivatedRoute } from '@angular/router';
import { UserApiService, User } from 'app/api/user.api.service';
import { AppSyncErrorService } from 'app/appsync-error.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private _currentUser: User;
  private _onCurrentUserChanged: BehaviorSubject<User>;

  // Protected
  protected logger: any;

  constructor(
    protected amplify: AmplifyService,
    protected router: Router,
    protected activatedRoute: ActivatedRoute,
    protected userApi: UserApiService,
    protected errorService: AppSyncErrorService
  ) {
    this.logger = this.amplify.logger('AuthService');
    this._currentUser = null;
    this._onCurrentUserChanged = new BehaviorSubject(null);

    this.onInit();
  }

  private _setCurrentUser(usr: User): void {
    this._currentUser = usr;
    this._onCurrentUserChanged.next(usr);
  }

  private async onInit(): Promise<void> {
    // Subscribe to Auth changes
    this.amplify.authStateChange$
      .subscribe(async authState => {
        switch (authState.state) {
          case 'signIn':
          case 'signedOut':
            this._setCurrentUser(null);
            await this.router.navigate(['auth/login']);
            break;

          case 'signedIn':
            this.userApi
            .Me()
            .then(async user => {
              this._setCurrentUser(user);
            })
            .catch(err => {
              this.logger.error(err);
            });
            break;
          default:
            break;
        }
      });
  }

  /**
   * Get onCurrentUserChanged
   *
   * @returns {Observable<User>}
   */
  get onCurrentUserChanged(): Observable<User> {
    return this._onCurrentUserChanged.asObservable();
  }

  /**
   * Get the current user
   *
   * @returns {User}
   */
  get currentUser(): User
  {
      return this._currentUser;
  }

}
